import React, {useEffect} from "react"

import {useAppDispatch, useAppSelector} from "../../store"
import {RootState} from "../../rootReducer"
import {fetchSchedules} from "./schedulesSlice"
import {MDBBreadcrumb, MDBBreadcrumbItem} from "mdbreact"
import {Field, Form, FormElement, FormRenderProps} from "@progress/kendo-react-form"

import AddEditSchedulesDialog from "../../components/DVSAScheduler/AddEditSchedulesDialog"
import DealerDropdown from "../../components/Shared/dealerDropdown"

import {DropDownListChangeEvent} from "@progress/kendo-react-dropdowns"
import AlertToastr from "../../components/Shared/alertToastr"
import DVSAScheduler from "../../components/DVSAScheduler/Scheduler"

const Schedules = () => {
    const dispatch = useAppDispatch()
    const userDealers = useAppSelector((state: RootState) => state.application.userDealers)
    const selectedDealer = useAppSelector((state: RootState) => state.application.selectedSingleDealer)

    const showNotification = useAppSelector((state: RootState) => state.containers.schedules.showNotification)

    useEffect(() => {
        if (selectedDealer) {
            dispatch(fetchSchedules(selectedDealer?.dealerId.toString()))
        }
    }, [dispatch, selectedDealer])

    const handleChange = (event: DropDownListChangeEvent) => {
        return false
    }

    return (
        <>
            <MDBBreadcrumb>
                <MDBBreadcrumbItem> Settings </MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>DVSA Schedules</MDBBreadcrumbItem>
            </MDBBreadcrumb>
            {userDealers && (
                <div className="mb-2">
                    <Form
                        onSubmit={() => {
                            return false
                        }}
                        render={(formRenderProps: FormRenderProps) => (
                            <div
                                className="mb-2"
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "end",
                                }}
                            >
                                <FormElement style={{width: 300}}>
                                    <fieldset className={"k-form-fieldset"}>
                                        <Field
                                            onChange={handleChange}
                                            name={"schedulesDealerDropdown"}
                                            component={DealerDropdown}
                                        />
                                    </fieldset>
                                </FormElement>
                            </div>
                        )}
                    />
                </div>
            )}

            {selectedDealer && <DVSAScheduler />}

            <AlertToastr />

            <AddEditSchedulesDialog />
        </>
    )
}
export default Schedules
